import React from 'react';
import { isExternalLoginEnabled } from '@config/ssoConfig';
import ExternalLogin from './ExternalLogin';
import LoginForm from './LoginForm';
import { EmbeddedLoginProps } from '../types';

const Index = ({ embedded = false }: EmbeddedLoginProps) => (
  isExternalLoginEnabled()
    ? <ExternalLogin embedded={embedded} />
    : <LoginForm embedded={embedded} />
);

Index.defaultProps = {
  embedded: false,
};

export default Index;
